/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Dgmm_TitleInputs */

const es_landing_price_dgmm_title = /** @type {(inputs: Landing_Price_Dgmm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasa oficial DGMM`)
};

const gl_landing_price_dgmm_title = /** @type {(inputs: Landing_Price_Dgmm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasa oficial DGMM`)
};

const en_landing_price_dgmm_title = /** @type {(inputs: Landing_Price_Dgmm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official DGMM fee`)
};

/**
* | output |
* | --- |
* | "Official DGMM fee" |
*
* @param {Landing_Price_Dgmm_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_dgmm_title = /** @type {((inputs?: Landing_Price_Dgmm_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Dgmm_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_dgmm_title(inputs)
	if (locale === "en") return en_landing_price_dgmm_title(inputs)
	return es_landing_price_dgmm_title(inputs)
});